"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Contact;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// All translations related to contact data
var Contact = (_Contact = {
  contacts: {
    nl: "Contactpersonen",
    fr: "Les contacts",
    en: "Contacts",
    de: "Kontakte"
  },
  reason_of_contact: {
    nl: "Reden van contact",
    fr: "Motif du contact",
    en: "Reason of contact",
    de: "Kontaktgrund"
  },
  contact_message: {
    nl: "Uw bericht",
    fr: "Votre message",
    en: "Your message",
    de: "Ihre Nachricht"
  },
  make_appointment: {
    nl: 'Maak een afspraak',
    fr: 'Rendez-vous',
    en: 'Make an appointment',
    de: 'Einen Termin vereinbaren'
  },
  send: {
    nl: "Email verzenden",
    fr: "Envoyer email",
    en: "Send email",
    de: "E-Mail senden"
  },
  copy_email: {
    nl: "U ontvangt een kopie van deze e-mail",
    fr: "Vous recevrez une copie de cet e-mail",
    en: "You will receive a copy of this email",
    de: "Sie erhalten eine Kopie dieser E-Mail"
  },
  contactInfoEnterprise: {
    nl: "Contact informatie onderneming",
    fr: "Information contact d'entreprise",
    en: "Enterprise contact information",
    de: "Unternehmens-Kontaktinformationen"
  },
  titleSocialMedia: {
    nl: "Social media en CMP",
    fr: "Social media et CMP",
    en: "Social media and CMP",
    de: "Soziale Medien und CMP"
  },
  phone_cbe: {
    nl: "Telefoon KBO",
    fr: "Telephone BCE",
    en: "Telephone CBE",
    de: "Telefon KBO"
  },
  phone: {
    nl: "Telefoon",
    fr: "Telephone",
    en: "Telephone",
    de: "Telefon"
  },
  fax_cbe: {
    nl: "Fax KBO",
    fr: "Fax BCE",
    en: "Fax CBE",
    de: "Fax KBO"
  },
  fax: {
    nl: "Fax",
    fr: "Fax",
    en: "Fax",
    de: "Fax"
  },
  cellphone_cbe: {
    nl: "GSM nummer KBO",
    fr: "Numéro portable BCE",
    en: "Cellphone CBE",
    de: "Handynummer KBO"
  },
  cellphone: {
    nl: "GSM nummer",
    fr: "Numéro portable",
    en: "Cellphone",
    de: "Handy"
  },
  mail_cbe: {
    nl: "E-mailadres KBO",
    fr: "Adresse e-mail BCE",
    en: "E-mail address CBE",
    de: "E-Mail-Adresse KBO"
  },
  mail: {
    nl: "E-mailadres",
    fr: "Adresse e-mail",
    en: "E-mail address",
    de: "E-Mail-Adresse"
  },
  "function": {
    nl: "Functie",
    fr: "Function",
    en: "Function",
    de: "Funktion"
  },
  website_cbe: {
    nl: "Website KBO",
    fr: "Site web BCE",
    en: "Website CBE",
    de: "Website KBO"
  },
  website: {
    nl: "Website",
    fr: "Site web",
    en: "Website",
    de: "Website"
  },
  onepage: {
    nl: "Onepage",
    fr: "Onepage",
    en: "Onepage",
    de: "Onepage"
  },
  eShop: {
    nl: "E-shop",
    fr: "E-shop",
    en: "E-shop",
    de: "E-Shop"
  },
  newsletter: {
    nl: "Nieuwsbrief",
    fr: "Circulaire",
    en: "Newsletter",
    de: "Newsletter"
  },
  cn: {
    nl: "Catalogusnetwerk",
    fr: "Réseau de Catalogue",
    en: "Catalogue network",
    de: "Katalognetzwerk"
  },
  pn: {
    nl: "Promonetwerk",
    fr: "Réseau de Promo",
    en: "Promo network",
    de: "Promo-Netzwerk"
  },
  payment_methods: {
    nl: "Betalingsmethodes",
    fr: "Modes de paiement",
    en: "Payment methods",
    de: "Zahlungsmethoden"
  },
  facilities: {
    nl: "Faciliteiten",
    fr: "Facilités",
    en: "Facilities",
    de: "Einrichtungen"
  },
  amenities: {
    nl: "Voorzieningen",
    fr: "Services",
    en: "Amenities",
    de: "Ausstattungen"
  },
  amenities_facilities: {
    nl: "Voorzieningen en faciliteiten",
    fr: "Services et équipements",
    en: "Amenities and facilities",
    de: "Ausstattungen und Einrichtungen"
  },
  associations: {
    nl: "Associaties",
    fr: "Associations",
    en: "Associations",
    de: "Verbände"
  },
  opening_hours: {
    nl: "Openingsuren",
    fr: "Heures d'ouverture",
    en: "Opening hours",
    de: "Öffnungszeiten"
  },
  contact_and_opening_hours: {
    nl: "Contact & openingsuren",
    fr: "Contact et heures d'ouverture",
    en: "Contact & opening hours",
    de: "Kontakt & Öffnungszeiten"
  },
  add_as_mobile_contact: {
    nl: "Voeg ons toe als mobiel contact",
    fr: "Ajoutez-nous comme contact mobile",
    en: "Add us as mobile contact",
    de: "Als Mobilkontakt hinzufügen"
  },
  add_as_contact: {
    nl: "Contact toevoegen",
    fr: "Ajouter le contact",
    en: "Add contact",
    de: "Kontakt hinzufügen"
  },
  esn_site: {
    nl: "https://ondernemersnetwerk.be",
    fr: "https://reseauentrepreneurs.be",
    en: "https://entrepreneursnetwork.be",
    de: "https://unternehmernetzwerk.be"
  },
  add_to: {
    nl: "Voeg toe aan",
    fr: "Ajouter à",
    en: "Add to",
    de: "Hinzufügen zu"
  },
  add_to_browser: {
    nl: "Voeg toe aan browser",
    fr: "Ajouter au navigateur",
    en: "Add to browser",
    de: "Zum Browser hinzufügen"
  }
}, _defineProperty(_Contact, "opening_hours", {
  nl: "Openingsuren",
  fr: "Heures d'ouverture",
  en: "Opening hours",
  de: "Öffnungszeiten"
}), _defineProperty(_Contact, "contact", {
  nl: "Contacteer",
  fr: "Contact",
  en: "Contact",
  de: "Kontakt"
}), _defineProperty(_Contact, "contact_distributor", {
  nl: "Contacteer verdeler",
  fr: "Contact distributeur",
  en: "Contact distributor",
  de: "Vertriebskontakt"
}), _defineProperty(_Contact, "paymentmethods", {
  nl: "Betalingsmethoden",
  fr: "Modes de paiement",
  en: "Payment methods",
  de: "Zahlungsmethoden"
}), _defineProperty(_Contact, "associaties", {
  nl: "Associaties",
  fr: "Les associations",
  en: "Associations",
  de: "Verbände"
}), _defineProperty(_Contact, "other", {
  nl: "Andere",
  fr: "Autre",
  en: "Other",
  de: "Andere"
}), _defineProperty(_Contact, "contact_persons", {
  nl: "Contactpersonen",
  fr: "Contacts",
  en: "Contacts",
  de: "Kontaktpersonen"
}), _defineProperty(_Contact, "no_email_form", {
  nl: "Geen email ingevoerd",
  fr: "Aucun e-mail entré",
  en: "No email entered",
  de: "Keine E-Mail eingegeben"
}), _defineProperty(_Contact, "invalid_email_form", {
  nl: "Geen geldig email",
  fr: "Aucun e-mail valide",
  en: "No valid email",
  de: "Keine gültige E-Mail"
}), _defineProperty(_Contact, "no_message_form", {
  nl: "Geen bericht ingevoerd",
  fr: "Aucun message saisi",
  en: "No message entered",
  de: "Keine Nachricht eingegeben"
}), _defineProperty(_Contact, "name_to_short_form", {
  nl: "Naam te kort",
  fr: "Le nom est court",
  en: "Name too short",
  de: "Name zu kurz"
}), _defineProperty(_Contact, "invalid_phone_form", {
  nl: "Geen geldig telefoon/GSM nummer",
  fr: "Aucun téléphone/GSM valide",
  en: "Invalid (cell)phone number",
  de: "Ungültige (Handy)Nummer"
}), _defineProperty(_Contact, "no_subject_form", {
  nl: "Geen onderwerp ingevoerd",
  fr: "Aucun assujettir saisi",
  en: "No subject entered",
  de: "Kein Betreff eingegeben"
}), _defineProperty(_Contact, "irea", {
  nl: "BIV",
  fr: "IPI",
  en: "IREA",
  de: "IREA"
}), _defineProperty(_Contact, "itaa", {
  nl: "ITAA",
  fr: "ITAA",
  en: "ITAA",
  de: "ITAA"
}), _defineProperty(_Contact, "rpr", {
  nl: "RPR",
  fr: "RPM",
  en: "RPR",
  de: "RPR"
}), _defineProperty(_Contact, "division", {
  nl: "afdeling",
  fr: "division",
  en: "division",
  de: "Abteilung"
}), _Contact);
var _default = Contact;
exports["default"] = _default;